import { configureStore } from "@reduxjs/toolkit";

import mapReducer from "../features/map/mapSlice";
import mapApiReducer from "../features/map/mapApiSlice";
import stateMapReducer from "../features/map/stateMapSlice";
import pinsReducer from "../features/map/pinsSlice";
import statisticsReducer from "../features/statistics/statisticsSlice";
import stateStatisticsReducer from "../features/statistics/stateStatisticsSlice";
import countriesAllReducer from "../features/countries/countriesAllSlice";
import countriesPerUserReducer from "../features/countries/countriesPerUserSlice";
import regionsReducer from "../features/regions/regionsSlice";
import usersReducer from "../features/users/usersSlice";

const store = configureStore({
  reducer: {
    map: mapReducer,
    mapApi: mapApiReducer,
    stateMap: stateMapReducer,
    pins: pinsReducer,
    statistics: statisticsReducer,
    stateStatistics: stateStatisticsReducer,
    countriesAll: countriesAllReducer,
    countriesPerUser: countriesPerUserReducer,
    regions: regionsReducer,
    users: usersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
